import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
    FaClock,
    FaEuroSign,
    FaCheck,
    FaTimes,
    FaCalendarAlt,
    FaArrowLeft
} from "react-icons/fa";

import { tours } from "../data/tours";
import "./TourDetail.css";

import  imgg2 from "../photos/tours_reg_silk_road1.png";


const TourDetails = () => {

    const { id } = useParams();
    const navigate = useNavigate();


    const tour = tours.find(
        (item) => item.id === Number(id)
    );


    if (!tour) {
        return (
            <div className="tour-not-found">

                <h2>
                    Tur topilmadi
                </h2>

                <button onClick={() => navigate("/tours")}>
                    Turlarga qaytish
                </button>

            </div>
        );
    }



    return (

        <section className="tour-details">


            {/* HERO */}

            <div className="tour-detail-hero">

                <img
                    src={imgg2}
                    alt={tour.title}
                />


                <div className="hero-content">


                    <h1>
                        {tour.title}
                    </h1>



                    <div className="hero-info">


                        <span>
                            <FaClock />
                            {tour.duration}
                        </span>



                        <span>
                            <FaEuroSign />
                            {tour.price}
                        </span>


                    </div>


                </div>


            </div>





            <div className="tour-detail-container">


                {/* BACK */}

                <button
                    className="back-btn"
                    onClick={() => navigate("/tours")}
                >
                    <FaArrowLeft />
                    Barcha turlar
                </button>





                {/* DESCRIPTION */}


                <div className="tour-intro">


                    <h2>
                        Sayohat haqida
                    </h2>



                    <p>
                        {tour.description}
                    </p>


                </div>







                {/* PROGRAM */}


                <div className="tour-program">


                    <h2>
                        Kunma-kun dastur
                    </h2>



                    <div className="timeline">


                        {tour.programme.map((day) => (


                            <div
                                className="timeline-item"
                                key={day.jour}
                            >


                                <div className="timeline-number">

                                    {day.jour}

                                </div>




                                <div className="timeline-content">


                                    <h3>

                                        <FaCalendarAlt />

                                        {day.titre}

                                    </h3>



                                    <span className="city">

                                        {day.ville}

                                    </span>



                                    <p>
                                        {day.description}
                                    </p>





                                    {
                                        day.activites?.length > 0 &&

                                        (

                                            <ul>

                                                {
                                                    day.activites.map(
                                                        (activity, index) => (

                                                            <li key={index}>
                                                                {activity}
                                                            </li>

                                                        )
                                                    )
                                                }

                                            </ul>

                                        )
                                    }



                                </div>


                            </div>



                        ))}



                    </div>



                </div>









                {/* INCLUDED */}



                <div className="included-section">



                    <div className="included-box">


                        <h2>
                            Tur narxiga kiradi
                        </h2>


                        <ul>

                            {
                                tour.inclus.map(
                                    (item, index) => (

                                        <li key={index}>

                                            <FaCheck />

                                            {item}

                                        </li>

                                    )
                                )
                            }


                        </ul>



                    </div>






                    <div className="not-included-box">


                        <h2>
                            Narxga kirmaydi
                        </h2>



                        <ul>

                            {
                                tour.nonInclus.map(
                                    (item, index) => (

                                        <li key={index}>

                                            <FaTimes />

                                            {item}

                                        </li>

                                    )
                                )
                            }


                        </ul>


                    </div>



                </div>







                {/* BOOKING */}

                <Link
                    to={`/tours/${tour.id}/booking`}
                    className="booking-button"
                >
                    Turni bron qilish
                </Link>




            </div>



        </section>

    );


};


export default TourDetails;